module.exports = __webpack_public_path__ + "static/media/source_lesson.881c87c6.svg";